import { Dictionary } from '@shared/dictionary';

import { UserType } from '../enums';


export const getUserTypeLabel = (dictionary: Dictionary, value: Users.Type) => {
  const MAP = {
    [UserType.Admin]: dictionary.users.labelTypeAdmin,
    [UserType.Homeowner]: dictionary.users.labelTypeHomeowner,
    [UserType.Partner]: dictionary.users.labelTypePartner,
  };

  return MAP[value];
};

export const getUserInitials = (name: string) => {
  const nameParts = name.trim().split(' ');
  if (nameParts.length === 0) return '';

  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  }

  const firstInitial = nameParts[0].charAt(0).toUpperCase();
  const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();

  return firstInitial + lastInitial;
};
